
/**
 * 本地存储超时时间
 * @constant
 * @type {Number}
 */
export const STORAGE_TIMEOUT = 10 * 60 * 1000;

/**
 * 本地存储key前缀
 * @constant
 * @type {String}
 */
export const STORAGE_KEY = 'WAP-MALL-ITEM';

/**
 * 常旅页面URL
 * @constant
 * @type {String}
 */
export const TOURIST_URL = '/userContacter/contacterList?choose=1';

/**
 * 最大成人数
 * @constant
 * @type {Number}
 */
export const MAX_ADULT = 999999;

/**
 * 最大儿童数
 * @constant
 * @type {Number}
 */
export const MAX_CHILD = 999999;

/**
 * 最小成人数
 * @constant
 * @type {Number}
 */
export const MIN_ADULT = 1;

/**
 * 最小儿童数
 * @constant
 * @type {Number}
 */
export const MIN_CHILD = 0;

/**
 * 最大单房差数
 * @constant
 * @type {Number}
 */
export const MAX_ROOM = 999999;

/**
 * 登陆页地址
 * @constant
 * @type {String}
 */
export const LOGIN_URL = '/u/login';

/**
 * 
 * @type {Number} min 
 * @type {NUmber} max 
 */
function makeNumArr(min, max) {
    let arr = []
    for (let i = min; i < max + 1; i++) {
        arr.push(i)
    }
    return arr;
}

export const NUM_TYPES = [
    {
        flex: 1,
        values: makeNumArr(1928, 2018) + "-" + makeNumArr(1, 12),
        className: 'picker_year',
        defaultIndex: 3,
        textAlign: 'center'
    },
    {
        flex: 1,
        values: makeNumArr(0, 31),
        className: 'picker_day',
        defaultIndex: 0,
        textAlign: 'center'
    }
];


// WEBPACK FOOTER //
// libs/config.js